import React, { useState, useEffect } from 'react'
import Layout from '../components/shared/layout'
import pricingData from '../components/utils/data/ourServices.json'
import { useParams, useNavigate } from 'react-router-dom'
import SEO from '../components/shared/seo'
import ImageIcons from '../components/imageComponent/ImageIcons'

const OurServices = () => {
  const { handle } = useParams()
  const navigate = useNavigate()
  const [serviceDetails, setServiceDetails] = useState(null)

  useEffect(() => {
    const selectedService = pricingData.find(
      service => service.handle === handle
    )
    if (!selectedService) {
      navigate('*')
    } else {
      setServiceDetails(selectedService)
    }
  }, [handle, navigate])

  if (!serviceDetails) return null

  return (
    <Layout>
      <SEO
        title={serviceDetails?.metaTitle}
        description={serviceDetails?.metaDescription}
        keywords={serviceDetails?.keywords}
      />

      <section className='relative md:py-[150px] max-md:py-[60px] after:content-[""] after:absolute after:left-0 after:right-0 after:top-0 after:w-full after:h-full after:bg-[#f48533] after:opacity-50'>
          <img  className='absolute top-0 left-0 w-full h-full object-cover object-center' src={ImageIcons.Broadband} alt='MyInternet Service' />
            <div className='heading_tittle container relative z-10'>
            <h1 className="capitalize text-white text-center tracking-[2px] drop-shadow-[0_0_5px_#00000052] mb-0">{serviceDetails?.title}</h1>
          </div>
      </section >

      {serviceDetails.ourServices && (
        <section>
          <div className='container'>
            <div className='grid lg:grid-cols-3 sm:grid-cols-2 lg:gap-[25px] gap-[20px]'>
              {serviceDetails.ourServices.map((item, index) => (
                <div
                  key={index}
                  className='bg-[#fafbff] lg:p-[25px] p-[20px] rounded-[5px] border-[#d5d5d5] border-[1px]'
                >
                  <h3 className='text-[#f18434]'>{item.title}</h3>
                  <p className='mb-0'>{item.description}</p>
                  {item.ourServicesList && (
                    <ul className='list-decimal pl-[20px]'>
                      {item.ourServicesList.map((list, i) => (
                        <li key={i} className='mb-[6px]'>{list.item}</li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
    </Layout>
  )
}

export default OurServices
